import * as React from 'react';

function SvgWarningTriangleOutline(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M15 13h2v7h-2zM16 22a1.5 1.5 0 101.53 1.49A1.49 1.49 0 0016 22z" />
      <path d="M16 2L.26 29h31.48zm0 4l12.26 21H3.74z" />
    </svg>
  );
}

export default SvgWarningTriangleOutline;
